import { render } from "./AddItemPick.vue?vue&type=template&id=1a2e3db3"
import script from "./AddItemPick.vue?vue&type=script&lang=js"
export * from "./AddItemPick.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__